import { CardContent, Typography } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { dealerSchema } from '../Dealer';
import * as yup from 'yup';


let DealerType = () => {

    type Dealer = yup.InferType<typeof dealerSchema>;
    let form = useFormikContext<Dealer>();

    return (
        <CardContent>
            <Typography gutterBottom variant="h4">Dealer Type</Typography>
            <Typography>
                {form.values.isDealer && 'Dealer'}
                {form.values.isDistributor && 'Distributor'}
            </Typography>
        </CardContent>
    )
}


export default DealerType;